import { render, staticRenderFns } from "./StavkeServisneFakture.vue?vue&type=template&id=0190841c&scoped=true&"
import script from "./StavkeServisneFakture.vue?vue&type=script&lang=ts&"
export * from "./StavkeServisneFakture.vue?vue&type=script&lang=ts&"
import style0 from "./StavkeServisneFakture.vue?vue&type=style&index=0&id=0190841c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0190841c",
  null
  
)

export default component.exports